export const SaveZsyncgl = async (dataJson: any) => {
  const respone = await fetch("api/GLAccount/SaveGLAccount", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ZSYNCGLs: Array.isArray(dataJson) ? dataJson : [dataJson],
    }),
  })
    .then((response) => response.json())
    .then((data) => {
      return data;
    });

  return respone;
};
